/**
 * Manages all user api interactions
 *
 * Copyright (c) 2019 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import axios from 'axios'
import queryString from 'query-string'
import apiConfig from 'common/configs/api'
import { getHeaders } from '../../auth/api'
import * as profileApi from './profile'
import * as followsApi from './follows'
import * as feedsApi from './feeds'
import * as settingsApi from './settings'

const { apiUrl, users, featureFlags } = apiConfig
const usersUrl = `${apiUrl}${users.url}`

export const newUserSignup = (userId, data) => {
  const signupUrl = `${usersUrl}${users.signup}`
  const headers = getHeaders()

  return axios.post(signupUrl, data, { headers })
}

export const deleteUser = (userId) => {
  const headers = getHeaders()

  return axios.delete(`${usersUrl}/${userId}`, { headers })
}

export const getUser = (userId, options = {}) => {
  const headers = getHeaders()
  const includeProfileFeatureFlagsQuery = queryString.stringify({
    includeProfile: true,
    includeFeatureFlags: true,
    includeFollows: true,
    ...options
  })

  return axios.get(`${usersUrl}/${userId}?${includeProfileFeatureFlagsQuery}`, { headers })
}

export const updateUsername = (userId, data) => {
  const usernameUrl = `${usersUrl}/${userId}${users.username}`
  const headers = getHeaders()

  return axios.put(usernameUrl, data, { headers })
}

export const updateFeatureFlags = (userId, featureName, data) => {
  const featureFlagsUrl = `${usersUrl}/${userId}${featureFlags.url}/${featureName}`
  const headers = getHeaders()

  return axios.patch(featureFlagsUrl, data, { headers })
}

export default {
  newUserSignup,
  deleteUser,
  getUser,
  updateUsername,
  updateFeatureFlags,
  ...profileApi,
  ...followsApi,
  ...feedsApi,
  ...settingsApi
}
